{
  "version": "6.1.1",
  "private": true,
  "sideEffects": false,
  "scripts": {
    "build": "remix build --sourcemap",
    "dev": "remix dev",
    "start": "remix-serve build/index.js",
    "eslint": "npx eslint \"app/**\"",
    "translations": "node app/commands/localization.js",
    "upload-source-maps": "node ./node_modules/@sentry/remix/scripts/sentry-upload-sourcemaps.js",
    "delete-source-maps": "find ./public/build -type f -name '*.map' -delete && find ./build -type f -name '*.map' -delete",
    "storybook": "storybook dev -p 6006",
    "storybook:build": "storybook build",
    "test": "vitest",
    "test:run": "vitest run",
    "test:ui": "vitest --ui",
    "test:ci": "vitest run --reporter=verbose --no-watch",
    "test:coverage": "vitest run --coverage",
    "clean:cache": "rm -rf node_modules/.cache",
    "redis:start": "docker-compose -f docker-compose.local.yml up -d redis",
    "redis:stop": "docker-compose -f docker-compose.local.yml down redis"
  },
  "dependencies": {
    "@amplitude/analytics-browser": "^2.17.9",
    "@amplitude/analytics-node": "^1.3.8",
    "@amplitude/experiment-js-client": "1.18.0",
    "@ark-ui/react": "^5.19.0",
    "@aws-sdk/client-s3": "^3.965.0",
    "@datadog/browser-logs": "^6.23.0",
    "@datadog/browser-rum": "^6.23.0",
    "@datadog/browser-rum-react": "^6.23.0",
    "@formkit/auto-animate": "0.8.1",
    "@headlessui/react": "^1.7.19",
    "@remix-run/node": "^2.2.0",
    "@remix-run/react": "^2.15.3",
    "@remix-run/serve": "^2.15.3",
    "@remix-run/v1-route-convention": "^0.1.4",
    "@remix-validated-form/with-zod": "^2.0.7",
    "@sentry/remix": "^7.120.4",
    "add-to-calendar-button-react": "^2.8.1",
    "axios": "^1.7.9",
    "cache-manager": "^5.7.6",
    "cookie": "^0.6.0",
    "crypto-js": "^4.2.0",
    "dd-trace": "^5.79.0",
    "echarts": "^6.0.0",
    "echarts-for-react": "^3.0.5",
    "form-data": "^4.0.1",
    "google-libphonenumber": "^3.2.40",
    "i18next": "^23.16.8",
    "i18next-browser-languagedetector": "^7.2.2",
    "i18next-fs-backend": "^2.6.0",
    "i18next-http-backend": "^2.7.3",
    "ibantools": "^4.5.4",
    "immer": "^10.1.1",
    "ioredis": "^5.5.0",
    "isbot": "^4.4.0",
    "jotai": "^2.14.0",
    "moment": "^2.30.1",
    "pdf-lib": "^1.17.1",
    "react": "^18.3.1",
    "react-confetti": "^6.4.0",
    "react-datepicker": "^6.9.0",
    "react-dom": "^18.3.1",
    "react-google-recaptcha": "^3.1.0",
    "react-i18next": "^14.1.3",
    "react-markdown": "^10.1.0",
    "react-phone-number-input": "^3.4.11",
    "react-popper": "^2.3.0",
    "react-share": "^5.2.0",
    "remix-auth": "^3.7.0",
    "remix-auth-form": "^1.5.0",
    "remix-auth-keycloak": "^1.2.0",
    "remix-i18next": "^5.5.0",
    "remix-redis-session": "^0.0.12",
    "remix-validated-form": "^5.1.5",
    "sonner": "^2.0.7",
    "string-strip-html": "^13.4.8",
    "use-immer": "^0.10.0",
    "validator": "^13.15.20",
    "winston": "^3.18.3",
    "zod": "^3.24.2",
    "zod-form-data": "^2.0.5"
  },
  "devDependencies": {
    "@remix-run/dev": "^2.15.3",
    "@remix-run/eslint-config": "^2.15.3",
    "@storybook/addon-docs": "^9.1.2",
    "@storybook/addon-links": "^9.1.2",
    "@storybook/addon-onboarding": "^9.1.2",
    "@storybook/react-vite": "^9.1.2",
    "@tailwindcss/forms": "^0.5.10",
    "@tailwindcss/typography": "^0.5.16",
    "@testing-library/jest-dom": "^6.9.1",
    "@testing-library/react": "^16.3.0",
    "@testing-library/user-event": "^14.6.1",
    "@types/crypto-js": "^4.2.2",
    "@types/google-libphonenumber": "^7.4.30",
    "@types/i18next-fs-backend": "^1.1.5",
    "@types/node": "^20.17.19",
    "@types/react": "^18.3.18",
    "@types/react-datepicker": "^4.19.6",
    "@types/react-dom": "^18.3.5",
    "@types/react-google-recaptcha": "^2.1.9",
    "@types/validator": "^13.15.4",
    "@types/winston": "^2.4.4",
    "@vitejs/plugin-react": "^5.0.4",
    "@vitest/coverage-v8": "^3.2.4",
    "@vitest/ui": "^3.2.4",
    "autoprefixer": "^10.4.20",
    "concurrently": "^8.2.2",
    "eslint": "^8.57.1",
    "eslint-plugin-storybook": "^9.1.2",
    "jsdom": "^27.0.0",
    "postcss": "^8.5.2",
    "postcss-cli": "^11.0.0",
    "postcss-import": "^16.1.0",
    "postcss-nesting": "^12.1.5",
    "postcss-rtlcss": "^5.6.0",
    "prettier": "^3.5.1",
    "prettier-plugin-tailwindcss": "^0.5.14",
    "storybook": "^9.1.2",
    "tailwindcss": "^3.4.17",
    "typescript": "^5.7.3",
    "vite-tsconfig-paths": "^5.1.4",
    "vitest": "^3.2.4"
  },
  "engines": {
    "node": ">=14"
  }
}
